import classnames from 'classnames/bind'
import { useTranslate } from 'react-polyglot'
import { GlobalThemeColors } from '~/@types/colors'
import { GlobalTextPreset } from '~/@types/text-preset'
import { GlobalTextStyling } from '~/@types/text-styling'

import { useStyle } from '~/providers/StyleProvider'

import { GENERAL } from '~/data/dictionary'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export interface ProductHeaderSubtitleProps {
  className?: string
  text?: string
  withOptional?: boolean
}

export function ProductHeaderSubtitle({
  className,
  text,
  withOptional,
}: ProductHeaderSubtitleProps) {
  const t = useTranslate()
  const subtitleStyle = useStyle({
    textPreset: GlobalTextPreset.Title12Primary,
    textStyling: GlobalTextStyling.UpperCase,
  })
  const optionalStyle = useStyle({
    textPreset: GlobalTextPreset.Text10Secondary,
    textStyling: GlobalTextStyling.UpperCase,
    color: GlobalThemeColors.Gray1ToBlack,
  })

  return (
    text && (
      <h2 className={cx(css.ProductHeaderSubtitle, className, subtitleStyle)}>
        {text}
        {withOptional && (
          <span className={cx(optionalStyle)}>{`(${t(
            GENERAL.OPTIONAL,
          )})`}</span>
        )}
      </h2>
    )
  )
}
